import React, {useContext} from "react";

import { buyNowContext } from "../BuyNow";
import { calcSalesTax } from "../../utils/pricingHelper";

/**
 * Return a string representing the total price of the order.
 */
const SalesTaxPrice = () => {
  const { lineItems, promoCode, salesTaxRates, shippingStageState } = useContext(buyNowContext);
  const { state, country } = shippingStageState;

  return calcSalesTax(lineItems, state, country, salesTaxRates, promoCode).toFixed(2);
};

export default SalesTaxPrice;